/**
 * Created by mengxiaojiang on 2016/5/10.
 */

var _ = require('underscore');
var dataHelper = require('./dataHelper');

/**
 * 中英文字体对应表
 * 直接使用中文字体名称可能会有问题, 应该使用英文名称
 */
var fontFamilyMap = {
  '微软雅黑': 'Microsoft Yahei',
  '宋体': 'SimSun'
};

function doMakeComp(comp) {
  if (!_.isUndefined(comp.controlProperties)) {
    var properties = comp.controlProperties;
    if (!_.isUndefined(properties.basic)) {
      _.extend(comp, properties.basic);
    }
    if (!_.isUndefined(properties.textSet)) {
      _.extend(comp, properties.textSet);
      if (!comp.text || _.isEmpty(comp.text)) {
        comp.text = '';   // 组件保存时，如果字符串为空，该属性未保存。
      }
    }
    if (!_.isUndefined(properties.scrollbar)) {
      //_.extend(comp, properties.scrollbar);
      comp.verticalScrollbarShow = properties.scrollbar.verticalScrollbar.isShow;
      comp.verticalScrollbarProgress = properties.scrollbar.verticalScrollbar.progress;
      comp.horizontalScrollbarShow = properties.scrollbar.horizontalScrollbar.isShow;
      comp.horizontalScrollbarProgress = properties.scrollbar.horizontalScrollbar.progress;
    }
    if (!_.isUndefined(properties.filter)) {
      _.extend(comp, properties.filter);
    }
    _.extend(comp, properties);

    comp.links = properties.links;
    comp.states = properties.states;
    comp.interactiveData = properties.interactiveData;
    comp.x = parseInt(comp.x, 10);
    comp.y = parseInt(comp.y, 10);
    comp.h = parseInt(comp.h, 10);
    comp.w = parseInt(comp.w, 10);


    if (comp.remarkText) {
      if (_.isEmpty(comp.remarkText)) {
        comp.remarkText = '';
      }

      comp.remarkText = dataHelper.decodeURI(comp.remarkText);
    }
    if (_.isEmpty(comp.externalURL)) {
      comp.externalURL = '';
    }
    if (_.isEmpty(comp.URL)) {
      comp.URL = '';
    }

    delete comp.controlProperties;
    delete comp.basic;
    delete comp.textSet;
  }

  if (!_.isUndefined(comp.groupChildrenDescriptors)) {
    comp.items = comp.groupChildrenDescriptors.control;
    if (comp.items) {
      comp.items.map(doMakeComp);
    }
    delete comp.groupChildrenDescriptors;
  }
  if (comp.textFontFamily) {
    comp.textFontFamily = fontFamilyMap[comp.textFontFamily] || comp.textFontFamily;
  }
  return comp;
}

exports.reconstruction = function (pageData) {
  var rootData;
  var i;

  if (pageData.mockup) {
    rootData = pageData.mockup;
  } else if (pageData.master) {
    rootData = pageData.master;
  } else {
    rootData = pageData;
  }

  if (!rootData) {
    console.dir(pageData);
  }

  if (!rootData.controls.control) { // 空白页面
    return;
  }

  for (i = 0; i < rootData.controls.control.length; i++) {
    doMakeComp(rootData.controls.control[i]);
  }
};


// WEBPACK FOOTER //
// ./src/helper/ReconstructionHelper.js